export default class KhLoadMore {
    constructor() {
        this.settings = {
            $postsList: $('.js-kh-posts-list')
        };
        this.bindUIActions();
    }

    bindUIActions = () => {
        if (this.settings.$postsList != null) {
            const postsList = this.settings.$postsList;
            const nrLoadMore = $('#js-nr-posts-default').val();
            const loadMoreBtn = $('.js-kh-load-more');

            const postTypeList = () => {
                $('.js-kh-post-single').removeClass('hidden');
                postsList.find('.js-kh-post-single').each((index, element) => {
                    if (index >= nrLoadMore) {
                        $(element).addClass('hidden');
                    }
                });
            };

            const updateShowingNr = () => {
                const showingNr = postsList.find('.js-kh-post-single:not(.hidden)').length;
                $('.js-current-nr').each(function() {
                    $(this).text(showingNr);
                });
            };

            // Call postTypeList and updateShowingNr initially
            postTypeList();
            updateShowingNr();

            // Call updateShowingNr when DOM is ready
            $(document).ready(updateShowingNr);

            if (postsList.find('.js-kh-post-single.hidden').length === 0) {
                loadMoreBtn.removeClass('btn').addClass('hidden');
            }

            loadMoreBtn.on('click', () => {
                const morePosts = postsList.find('.js-kh-post-single.hidden');
                let counter = 0;

                // Show more posts
                morePosts.each(function () {
                    if (counter >= nrLoadMore) {
                        return false;
                    }
                    counter++;
                    $(this).removeClass('hidden');
                });

                if (postsList.find('.js-kh-post-single.hidden').length === 0) {
                    loadMoreBtn.removeClass('btn').addClass('hidden');
                }
                updateShowingNr();
            });
        }
    };
}

$(document).ready(() => {
    new KhLoadMore();
});